module.exports = __webpack_public_path__ + "files/fc6ac1842093579b4fd110bcc444c4f4.png";